import React, { Children } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { AnimatedSection } from './AnimatedSection';
import { AnimatedText } from './AnimatedText';
const subsidiaries = [{
  id: 'palace-hotel',
  name: 'Solochus Palace Hotel Ltd',
  description: 'Luxury accommodations with world-class amenities and exceptional service.',
  icon: '🏨',
  color: 'bg-amber-100 text-amber-800',
  buttonColor: 'bg-amber-600 hover:bg-amber-700',
  path: '/palace-hotel'
}, {
  id: 'standard-purity',
  name: 'Standard Purity Ent.',
  description: 'Quality retail products and services with a commitment to excellence.',
  icon: '🛒',
  color: 'bg-emerald-100 text-emerald-800',
  buttonColor: 'bg-emerald-600 hover:bg-emerald-700',
  path: '/standard-purity'
}, {
  id: 'puritydefine',
  name: 'Puritydefine Nig Ltd',
  description: 'Innovative manufacturing solutions with a focus on quality and sustainability.',
  icon: '🏭',
  color: 'bg-blue-100 text-blue-800',
  buttonColor: 'bg-blue-600 hover:bg-blue-700',
  path: '/puritydefine'
}, {
  id: 'unique-buka',
  name: 'Unique Buka',
  description: 'Authentic culinary experiences celebrating local flavors and traditions.',
  icon: '🍲',
  color: 'bg-red-100 text-red-800',
  buttonColor: 'bg-red-600 hover:bg-red-700',
  path: '/unique-buka'
}];
export function SubsidiarySection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.3
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <section id="subsidiaries" className="py-20 bg-gray-50" data-id="element-477">
      <div className="container mx-auto px-4" data-id="element-478">
        <AnimatedSection className="text-center mb-16" data-id="element-479">
          <AnimatedText text="Our Companies" className="text-3xl md:text-4xl font-bold mb-4" as="h2" data-id="element-480" />
          <motion.p className="text-lg text-gray-600 max-w-2xl mx-auto" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7,
          delay: 0.3
        }} data-id="element-481">
            Discover the diverse portfolio of businesses under the Solochus
            Group umbrella, each delivering excellence in their respective
            industries.
          </motion.p>
        </AnimatedSection>
        <motion.div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} data-id="element-482">
          {subsidiaries.map(subsidiary => <motion.div key={subsidiary.id} className="bg-white rounded-lg shadow-md overflow-hidden" variants={itemVariants} whileHover={{
          y: -10,
          transition: {
            duration: 0.3
          }
        }} data-id="element-483">
              <motion.div className={`p-6 ${subsidiary.color}`} whileHover={{
            scale: 1.05
          }} transition={{
            duration: 0.3
          }} data-id="element-484">
                <span className="text-4xl" data-id="element-485">{subsidiary.icon}</span>
              </motion.div>
              <div className="p-6" data-id="element-486">
                <h3 className="text-xl font-bold mb-2" data-id="element-487">{subsidiary.name}</h3>
                <p className="text-gray-600 mb-4" data-id="element-488">{subsidiary.description}</p>
                <motion.div whileHover={{
              scale: 1.03
            }} whileTap={{
              scale: 0.97
            }} data-id="element-489">
                  <Link to={subsidiary.path} className={`block w-full py-2 text-center text-white font-medium rounded-md ${subsidiary.buttonColor} transition-colors`} data-id="element-490">
                    Visit Website
                  </Link>
                </motion.div>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}